import { useChat } from "@/context/ChatContext";
import { ChatConversation } from "@/components/chat/ChatConversation";
import { Avatar } from "@/components/shared/UI";
import { X, Maximize2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function ChatWindows() {
  const { windows, closeWindow, minimizeWindow } = useChat();
  if (!windows.length) return null;
  return (
    <div className="fixed bottom-0 right-4 z-[45] flex flex-row-reverse items-end gap-3" data-testid="chat-windows">
      {windows.map((w) => (
        <div
          key={w.id}
          data-testid={`chat-window-${w.id}`}
          className={cn(
            "flex w-[calc(100vw-2rem)] max-w-[330px] flex-col overflow-hidden rounded-t-xl border border-slate-200 bg-white shadow-2xl",
            w.minimized ? "h-auto" : "h-[460px] max-h-[72vh]"
          )}
        >
          {w.minimized && (
            <div className="flex items-center gap-2 px-3 py-2.5">
              <Avatar name={w.name} className="h-7 w-7 text-[11px]" />
              <button onClick={() => minimizeWindow(w.id, false)} data-testid={`chat-window-restore-${w.id}`}
                className="flex-1 truncate text-left text-sm font-semibold text-slate-800">{w.name}</button>
              <button onClick={() => minimizeWindow(w.id, false)} className="rounded p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600"><Maximize2 className="h-3.5 w-3.5" /></button>
              <button onClick={() => closeWindow(w.id)} data-testid={`chat-window-min-close-${w.id}`} className="rounded p-1 text-slate-400 hover:bg-red-50 hover:text-red-600"><X className="h-4 w-4" /></button>
            </div>
          )}
          {/* Keep the conversation mounted (just hidden) so drafts/edits/messages survive minimize/restore */}
          <div className={cn("min-h-0 min-w-0 flex-1", w.minimized && "hidden")}>
            <ChatConversation chatId={w.id} paused={w.minimized} onMinimize={() => minimizeWindow(w.id, true)} onClose={() => closeWindow(w.id)} />
          </div>
        </div>
      ))}
    </div>
  );
}
